export const TRANSACTION_CATEGORY = {
    SKI: 'ski',
    SNB: 'snb',
    WEX: 'wex',
    KID_SCHOOL: 'kid_school',
    PAYOUT_INDIVIDUAL: 'payout_individual',
    PAYOUT_WEX: 'payout_wex',
    PAYOUT_KID_SCHOOL: 'payout_kid_school',
    PAYOUT_STAFF: 'payout_staff',
    PAYOUT: 'payout',
    BONUS: 'bonus',
    PENALTY: 'penalty',
    SKI_EQUIPMENT: 'ski_equipment',
    SNB_EQUIPMENT: 'snb_equipment',
    KID_SCHOOL_EQUIPMENT: 'kid_school_equipment',
    CLOTHING: 'clothing',
    STORNO: 'storno',
    OTHER: 'other',
};
export const TRANSACTION_CATEGORIES = [
    {
        id: TRANSACTION_CATEGORY.SKI,
        title: 'Lyže - Individuální výuka',
    },
    {
        id: TRANSACTION_CATEGORY.SNB,
        title: 'SNB - Individuální výuka',
    },
    {
        id: TRANSACTION_CATEGORY.WEX,
        title: 'WEX - Individuální výuka',
    },
    {
        id: TRANSACTION_CATEGORY.KID_SCHOOL,
        title: 'Dětská školka',
    },
    {
        id: TRANSACTION_CATEGORY.PAYOUT_INDIVIDUAL,
        title: 'Mzda - Individuální výuka',
    },
    {
        id: TRANSACTION_CATEGORY.PAYOUT_WEX,
        title: 'Mzda - WEX',
    },
    {
        id: TRANSACTION_CATEGORY.PAYOUT_KID_SCHOOL,
        title: 'Mzda - Dětská školka',
    },
    {
        id: TRANSACTION_CATEGORY.PAYOUT_STAFF,
        title: 'Mzda - Služba',
    },
    {
        id: TRANSACTION_CATEGORY.PAYOUT,
        title: 'Dorovnání účtu',
    },
    {
        id: TRANSACTION_CATEGORY.BONUS,
        title: 'Prémie',
    },
    {
        id: TRANSACTION_CATEGORY.PENALTY,
        title: 'Pokuta',
    },
    {
        id: 'ski_equipment',
        title: 'Lyže - Vybavení',
    },
    {
        id: TRANSACTION_CATEGORY.SNB_EQUIPMENT,
        title: 'SNB - Vybavení',
    },
    {
        id: TRANSACTION_CATEGORY.KID_SCHOOL_EQUIPMENT,
        title: 'Dětská školka - Vybavení',
    },
    {
        id: TRANSACTION_CATEGORY.CLOTHING,
        title: 'Oblečení - Vybavení',
    },
    {
        id: TRANSACTION_CATEGORY.STORNO,
        title: 'Storno výuky',
    },
    {
        id: TRANSACTION_CATEGORY.OTHER,
        title: 'Ostatní výdeje a příjmy',
    },
];
